<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Categories
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Category Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save category
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
  <script>
import axios from "axios";
export default {
  name: "CategoryCreatePage",
  data() {
    return {
      form: {
        name: "",
        parent_id: null,
      },
      isLoading: false,
    };
  },

  methods: {
    async save() {
      try {
        this.isLoading = true;
        let notifications = await axios.post("/categories", this.form);
        this.notifications = notifications.data.data;

        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/categories");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
  